/// <amd-module name="Artifacts/Sample/redux/Actions" />

import { ActionsUnion, createAction } from "redux/Utils/ActionHelper";

export const enum SampleActionTypes {
  HelloWorld = "Artifacts/Sample/HelloWorld",
}

export const SampleActions = {
  helloWorld: () => createAction(SampleActionTypes.HelloWorld),
};

export type SimpleActionUnion = ActionsUnion<typeof SampleActions>;
